<template>
  <VNavigationDrawer
    :rail="!isOpen"
    :color="color"
    :width="width"
    :floating="true"
    :permanent="true"
    class="drawer"
    @click="$emit('update:isOpen', true)"
  >
    <template #prepend>
      <slot name="prepend-content" />
    </template>
    <slot />
  </VNavigationDrawer>
</template>

<script setup lang="ts">
import { VNavigationDrawer } from 'vuetify/components/VNavigationDrawer';

interface Props {
  isOpen: boolean;
  color?: string;
  width?: string | number;
}

withDefaults(defineProps<Props>(), {
  color: 'white',
  width: '250',
});

defineEmits<(e: 'update:isOpen', value: boolean) => void>();
</script>

<style scoped lang="scss">
:deep(.v-navigation-drawer__content) {
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

:deep(.v-list-item__prepend > .v-icon ~ .v-list-item__spacer) {
  width: 8px;
}

:deep(.v-list-item__append > .v-badge ~ .v-list-item__spacer) {
  width: 7px;
}

.drawer.v-navigation-drawer--floating {
  border-left: 1px solid rgb(var(--v-theme-border-secondary));
}
</style>
